<template>
  <div>
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="8">
          <v-card class="card--shadow pa-2">
            <v-card-text>
              <v-row>
                <v-col class="col--padding" lg="3">
                  <label>Month <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="handleFieldErrors($v.month)"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding" lg="4">
                  <label>Year <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="years"
                    v-model="year"
                    item-text="text"
                    item-value="value"
                    :error-messages="handleFieldErrors($v.year)"
                    dense
                    outlined
                  ></v-select>
                </v-col>
               
                <v-col class="col--padding" lg="4" >
                  <label>Townships <require-sign /></label>
                  <v-select
                    class="mr-3"
                    v-model="township_id"
                    placeholder="choose township..."
                    :error-messages="handleFieldErrors($v.township_id)"
                    hide-details
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="townships"
                    
                  >
                  </v-select>
                </v-col>
                
              </v-row>
              <v-row justify="center">
                <v-col class="col--padding" lg="4">
                  <div>
                    <v-btn
                      height="40"
                      color="purple accent-4"
                      @click.prevent="viewMontlyList"
                      outlined
                      rounded
                      dark
                    >
                      view report
                      <v-icon right>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
export default {
  components: { BackBtn ,RequireSign},
  mixins: [ValidationMixin],
  data: () => ({
    month: null,
    year: null,
    township_id: null,
  }),
  validations: {
    month: {
      required,
    },
    year: {
      required,
    },
   
    township_id: {
      required,
    },
  },
  methods: {
    viewMontlyList() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$router.push({
          name: "monthly-list-report",
          query: {
            month: this.month,
            year: this.year,
            township_id: this.township_id,
            township_name: 
            this.townships.find(
              (twn) => twn.id === this.township_id
            ).name,
          },
        });
      }
    },
  },
  computed: {
    ...mapState("InitialData", ["export_months", "years"]),
    ...mapState("Township", ["townships"]),
    ...mapState("Loading", ["loading"]),
  },
  created() {
    this.$store.dispatch("Township/getTownships");
  },
};
</script>
